import { cn } from "@/lib/utils";
import { StatusBadge } from "@/components/common";

const STATUS = { valid: ["success", "Ready"], error: ["failed", "Error"], skip: ["pending", "Skipped"] };
const show = (v) => (v == null ? "" : Array.isArray(v) ? v.join(", ") : String(v));

export function PreviewTable({ session, filter }) {
  const mapped = new Set(Object.values(session.mapping).filter(Boolean));
  const cols = session.fields.filter((f) => mapped.has(f.key) || f.required);
  const rows = session.rows.filter((r) => filter === "all" || r.status === filter).slice(0, 500);
  return (
    <div className="max-h-[480px] overflow-auto" data-testid="import-preview-table">
      <table className="po-table">
        <thead className="sticky top-0 bg-white"><tr><th>Row</th><th>Status</th>{cols.map((c) => <th key={c.key}>{c.label}{c.required ? " *" : ""}</th>)}<th>Notes</th></tr></thead>
        <tbody>{rows.map((r) => (
          <tr key={r.row} data-testid={`preview-row-${r.row}`} className={cn(r.status === "error" && "bg-rose-50/40")}>
            <td className="tabular-nums text-slate-500">{r.row}</td>
            <td><StatusBadge status={STATUS[r.status][0]} label={STATUS[r.status][1]} testId={`preview-status-${r.row}`} /></td>
            {cols.map((c) => {
              const err = r.errors[c.key];
              return (
                <td key={c.key} title={err || ""} data-testid={`preview-cell-${r.row}-${c.key}`}
                  className={cn(err && "bg-rose-100 text-rose-800 ring-1 ring-inset ring-rose-300")}>
                  <div>{show(r.values[c.key]) || r.raw?.[c.key] || (err ? <span className="italic">empty</span> : "")}</div>
                  {err && <div className="mt-0.5 text-[11px] font-medium" data-testid={`preview-error-${r.row}-${c.key}`}>{err}</div>}
                </td>
              );
            })}
            <td className="max-w-[260px] text-xs text-amber-700">{r.warning}</td>
          </tr>))}</tbody>
      </table>
      {rows.length === 0 && <p className="py-8 text-center text-sm text-slate-400">No rows in this view.</p>}
    </div>
  );
}
